// Most polyfills for JS features should by loaded automatically by babel

if (!Object.fromEntries) {
  Object.fromEntries = function fromEntries(iterable) {
    return [...iterable].reduce((obj, { 0: key, 1: val }) => {
      obj[key] = val; // eslint-disable-line no-param-reassign
      return obj;
    }, {});
  };
}



// WEBPACK FOOTER //
// ./src/scripts/modules/polyfills.js